import R from 'app/assets/R'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { useModalHook } from './hook'
import * as S from './styles'
import { IPropsUpdateMaterialCategory, initValues } from './type'

export const Update = (props: IPropsUpdateMaterialCategory) => {
  const {
    form,
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
  } = useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="update"
      titleKeyI18n={R.strings.material_category_update}
      content={
        <BaseForm
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
          initialValues={initValues}
          form={form}
        >
          <S.FormItem
            name="id"
            label={t(R.strings.code)}
          >
            <S.FormInput
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.code),
              })}
            />
          </S.FormItem>
          <S.FormItem
            name="TIN"
            label={t(R.strings.TIN)}
          >
            <S.FormInput
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.TIN),
              })}
            />
          </S.FormItem>

          <S.FormItem
            name="vat"
            label={t(R.strings.material_vat)}
          >
            <S.FormInput
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.material_vat),
              })}
            />
          </S.FormItem>
        </BaseForm>
      }
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.material_category_update}
      confirmKeyI18n={R.strings.material_category_update}
      handleSubmit={form.submit}
      visible={visible}
    />
  )
}
